'use strict';

angular
  .module('cfn')
  .factory('changeEmailService', changeEmailService);

changeEmailService.$inject = ['$http'];

function changeEmailService($http) {
  return {
    resendConfirmationMail: resendConfirmationMail,
    updateEmailAddress: updateEmailAddress,
    getLatestEmailChange: getLatestEmailChange,
  };

  function resendConfirmationMail(newEmailAddress) {
    return updateEmailAddress(newEmailAddress);
  }

  function updateEmailAddress(newEmailAddress) {
    var request = {
      method: 'PUT',
      url: `/365FarmNet/mod/signon/rest/v1.0/email-confirmation-requests`,
      data: {
        emailAddress: newEmailAddress
      },
    };

    return $http(request);
  }

  function getLatestEmailChange() {
    var request = {
      method: 'GET',
      url: `/365FarmNet/mod/signon/rest/v1.0/email-confirmation-requests/latest-pending`,
    };
    
    return $http(request);
  }
}
